import {lastNDays, toDay, lastNMonth} from 'app/format/date'

export const getDateRange = ({days, month}: any) => {
  const Date = [
    {
      id: '1',
      text: 'Last 7 Days',
      fromDate: lastNDays(days, 6),
      toDate: toDay(),
    },
    {
      id: '2',
      text: 'Last 30 Days',
      fromDate: lastNDays(days, 29),
      toDate: toDay(),
    },
    {
      id: '3',
      text: 'This Month',
      fromDate: toDay().startOf('month'),
      toDate: toDay().endOf('month'),
    },
    {
      id: '4',
      text: 'Last Month',
      fromDate: lastNMonth(month, 1).startOf('month'),
      toDate: lastNMonth(month, 1).endOf('month'),
    },
    {
      id: '5',
      text: 'Week to Date',
      fromDate: toDay().startOf('week'),
      toDate: toDay(),
    },
    {
      id: '6',
      text: 'Month to Date',
      fromDate: toDay().startOf('month'),
      toDate: toDay(),
    },
    {
      id: '7',
      text: 'Year to Date',
      fromDate: toDay().startOf('year'),
      toDate: toDay(),
    },
    {
      id: '8',
      text: 'Today',
      fromDate: toDay().startOf('day'),
      toDate: toDay().endOf('day'),
    },
  ]
  return Date
}

export const YAxisFormat = (number: any) => {
  if (number > 1000000000) {
    return '$' + (number / 1000000000).toString() + 'B'
  } else if (number > 1000000) {
    return '$' + (number / 1000000).toString() + 'M'
  } else if (number > 1000) {
    return '$' + (number / 1000).toString() + 'K'
  } else {
    return '$' + number.toString()
  }
}
